import { Money } from "./money.model"
export class TicketFee {
	fee: Money
	ticketFeeType: string;
}



// WEBPACK FOOTER //
// ./src/app/models/ticket-fee.model.ts